<template>
  <div class="canceldata">
    <toptitle :title1="titlework" />
    <section class="cancelsec">
      <h3>休假信息</h3>
      <p>单据号：{{ items.C_APPLI_NUMB }}</p>
      <p>开始日期：{{ items.BEGIN_DT }}</p>
      <p>开始时间：{{ items.C_START_TM }}</p>
      <p>结束日期：{{ items.END_DT }}</p>
      <p>结束时间：{{ items.C_END_TM }}</p>
      <p>请假时长：{{ items.C_DURATION }}</p>
      <p>休假原因：{{ items.REASON }}</p>
      <p>备注：</p>
    </section>
    <van-checkbox-group v-model="result">
      <van-cell-group
        style="margin-bottom: 10px"
        v-for="(item, index) in lines"
        :key="index"
      >
        <div class="input1">
          <p>
            <van-checkbox
              :disabled="item.C_FLAG == 'Y' ? true : false"
              :name="index"
              >是否销假</van-checkbox
            >
          </p>
          <p class="type">
            销假类型<span>{{ item.C_SEQ5 }}</span>
          </p>
        </div>
        <van-field
          disabled
          v-model="item.C_START_DT"
          label="销假日期"
          value="123"
        />
        <van-field disabled v-model="item.C_START_DTM" label="开始时间" />
        <van-field disabled v-model="item.C_END_DTM" label="结束时间" />
        <van-field disabled v-model="item.C_HOLI_HOURS" label="销假时长" />
      </van-cell-group>
    </van-checkbox-group>
    <van-field
      class="reason"
      v-model="reason"
      required
      autosize
      label="备注"
      type="textarea"
      maxlength="50"
      placeholder="请输入销假原因"
      show-word-limit
    />
    <div @click="submit" class="submit">提交</div>
    <div v-if="show1" class="button-bt1"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import toptitle from "../toptitle";
import { aparkRestDataApi, cBalacneDataApi } from "../../request/api";
// import _ from "lodash";
import { throttle } from "../../utils/throttle";
export default {
  name: "canceldata",
  data() {
    return {
      titlework: "销假申请",
      items: this.$store.state.canceldata,
      input: false,
      reason: "",
      lines: [],
      result: [],
      show1: false,
    };
  },
  methods: {
    submit() {
      this.show1 = true;
      if (this.result.length == 0) {
        this.show1 = false;
        Toast("该流程已提交 / 请选择提交项");
        return;
      }
      if (!this.reason) {
        this.show1 = false;
        Toast("请填写原因");
        return;
      }
      let _this = this;
      let arr = [];
      for (let i = 0; i < _this.lines.length; i++) {
        arr.push({
          C_FLAG: _this.lines[i].C_FLAG,
          EMPLID: sessionStorage.getItem("EMPLID"),
          C_START_DT: _this.lines[i].C_START_DT,
          C_START_DTM: _this.lines[i].C_START_DTM,
          C_END_DTM: _this.lines[i].C_END_DTM,
        });
      }
      for (let j = 0; j < _this.result.length; j++) {
        arr[_this.result[j]].C_FLAG = "Y";
      }
      let params = {
        C_LEAVE_NUM: _this.items.C_APPLI_NUMB,
        EMPLID: sessionStorage.getItem("EMPLID"),
        COMMENTS: _this.reason,
        LINES: arr,
      };
      cBalacneDataApi(params).then((res) => {
        if (res.C_BAS_INFO_RES.RESULTCODE == 1) {
          Toast.success("提交成功");
          this.$router.push("/cancelrec");
        } else {
          Toast(res.C_BAS_INFO_RES.RESULTMSG);
          this.show1 = false;
        }
      });
    },
  },
  components: {
    toptitle,
  },
  created() {
    let id = sessionStorage.getItem("EMPLID");
    let params = {
      C_APPLI_NUMB: this.$store.state.canceldata.C_APPLI_NUMB,
      EMPLID: id,
    };
    aparkRestDataApi(params).then((res) => {
      console.log(res);
      if (res.RESULTCODE == 1) {
        let { Lines } = res.DATA;
        this.lines = Lines;
        console.log(this.lines);
      }
    });
  },
};
</script>

<style lang="less" scoped >
.cancelsec {
  margin: 10px 14px;
  background: white;
  padding: 5px 14px;
  border-radius: 10px;
  h3 {
    font-size: 16px;
    line-height: 40px;
  }
  p {
    font-size: 15px;
    line-height: 22px;
    color: #8f8f8f;
  }
}
/deep/.van-field__control {
  text-align: right;
}
.input1 {
  display: flex;
  padding: 0 14px;
  line-height: 44px;
  font-size: 14px;
  /deep/.van-checkbox {
    margin-top: 12px;
  }
  p {
    width: 50%;
    border-bottom: 1px solid #ebedf0;
  }
  .type {
    text-align: right;
    span {
      margin-left: 20px;
    }
  }
}
.reason {
  margin: 10px 0 60px;
}
.submit {
  position: fixed;
  bottom: 0;
  width: 100%;
  color: white;
  background: #733e2a;
  line-height: 44px;
  text-align: center;
  height: 44px;
}
.button-bt1 {
  position: fixed;
  bottom: 0;
  display: flex;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
}
</style>